const printElem = (elementId, title = null, width = 800, height = 600) => {
  let newWindow = window.open('', 'PRINT', `height=${height},width=${width}`);

  newWindow.document.write('<html><head><title>' + `${title || document.title}` + '</title>');
  newWindow.document.write('</head><body>');
  newWindow.document.write('<h1>' + `${title || document.title}` + '</h1>');
  newWindow.document.write(document.getElementById(elementId).innerHTML);
  newWindow.document.write('</body></html>');

  newWindow.document.close(); // necessary for IE >= 10
  newWindow.focus(); // necessary for IE >= 10*/

  newWindow.print();
  newWindow.close();
};

export default printElem;
